import script from "./FeatureGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./FeatureGuide.vue?vue&type=script&setup=true&lang=js"

import "./FeatureGuide.vue?vue&type=style&index=0&id=38501fcc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38501fcc"]])

export default __exports__